<script lang="ts" setup>
    import { Str } from '@supercharge/strings/dist';
    import GlobalSearchItem from '@/app/common/models/GlobalSearchItem';

    const props = defineProps<{
        result: GlobalSearchItem;
    }>();
</script>

<template>
    <AppSearchModalResult
        icon="fa-bullseye-arrow"
        :result="result"
    >
        <template v-slot>
            <span class="block text-sm text-gray-800">
                {{ result.title }}
            </span>
            <span
                class="block text-xs text-gray-600"
                v-if="result.contact"
            >
                {{ result.contact.lastName }}
            </span>
        </template>
        <template v-slot:right>
            <span class="px-2 py-[3px] text-[8px] text-white uppercase bg-neutral-600 rounded-full">
                {{ $t(`crm.leads.status.${Str(result.lead.status).toLowerCase().toString()}`) }}
            </span>
        </template>
    </AppSearchModalResult>
</template>
